var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "card has-background-dark has-text-light",
      attrs: { id: "map-filter" },
    },
    [
      _c("header", { staticClass: "card-header" }, [
        _c("p", { staticClass: "card-header-title has-text-light" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("filter")) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c(
              "b-switch",
              {
                attrs: { type: "is-danger" },
                on: { input: _vm.filter },
                model: {
                  value: _vm.red,
                  callback: function ($$v) {
                    _vm.red = $$v
                  },
                  expression: "red",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("not compliant")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c(
              "b-switch",
              {
                attrs: { type: "is-warning" },
                on: { input: _vm.filter },
                model: {
                  value: _vm.yellow,
                  callback: function ($$v) {
                    _vm.yellow = $$v
                  },
                  expression: "yellow",
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("not sure")) + "\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c(
              "b-switch",
              {
                attrs: { type: "is-success" },
                on: { input: _vm.filter },
                model: {
                  value: _vm.green,
                  callback: function ($$v) {
                    _vm.green = $$v
                  },
                  expression: "green",
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("compliant")) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }